import React from "react";
import PropTypes from "prop-types";
import { kebabCase } from "lodash";
import RlNavAccordionItem from "./RlNavAccordionItem";

const RlNavHeaderItem = ({
  text,
  textClassName,
  label,
  children,
  icon,
  iconClassName,
  expanded = false,
  topLevel = false,
  topLevelStatic = false,
  image,
  link,
  linkState,
  helpText,
  "data-testid": dataTestId,
  show = true
}) => {
  const accordionKey = kebabCase(text);

  if (!show) {
    return null;
  }

  return (
    <RlNavAccordionItem
      topLevel={topLevel}
      topLevelStatic={topLevelStatic}
      icon={icon}
      iconClassName={iconClassName}
      text={text}
      textClassName={textClassName}
      label={label}
      image={image}
      link={link}
      linkState={linkState}
      helpText={helpText}
      data-testid={dataTestId || accordionKey}
      expanded={expanded}
    >
      {children}
    </RlNavAccordionItem>
  );
};

RlNavHeaderItem.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  textClassName: PropTypes.string,
  label: PropTypes.node,
  children: PropTypes.node,
  icon: PropTypes.string,
  iconClassName: PropTypes.string,
  expanded: PropTypes.bool,
  topLevel: PropTypes.bool,
  topLevelStatic: PropTypes.bool,
  image: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string
  }),
  link: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  linkState: PropTypes.any,
  helpText: PropTypes.string,
  "data-testid": PropTypes.string,
  show: PropTypes.bool
};

export default RlNavHeaderItem;
